export default __webpack_public_path__ + "static/media/csango10-13kerulet-elado-lakasok-3.e274a576.webp";